import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Select } from 'foundations-components/transitional/components/Select';
import { FormControl } from 'foundations-components/transitional/components/FormControl';
import { useApprovalContext } from '../hooks/useApprovalContext';
import { useFetchUsersByScope } from '../hooks/useFetchUsersByScope';
import { maxNumberOfApprovers } from '../utils/approvalModalUtils';
import { buildApproverOption } from '../utils/approverSelectUtils';
import { ACTOR } from '../constants/actors';
import { jsx as _jsx } from "react/jsx-runtime";
export const ApproverSelect = ({
  approvers,
  value,
  onChange
}) => {
  var _approval$meta$curren;
  const approval = useApprovalContext();
  const currentUserId = (_approval$meta$curren = approval.meta.currentUser) === null || _approval$meta$curren === void 0 ? void 0 : _approval$meta$curren.user_id;
  const {
    users: superAdminUsers
  } = useFetchUsersByScope('super-admin');
  const superAdminUserIds = useMemo(() => new Set(superAdminUsers.map(user => String(user.id))), [superAdminUsers]);
  const options = useMemo(() => approvers.filter(approver => approver.actor.actorType !== ACTOR.USER || approver.actor.id !== String(currentUserId)).map(approver => buildApproverOption({
    approver,
    superAdminUserIds
  })), [approvers, superAdminUserIds, currentUserId]);
  const onChangeApprover = evt => {
    onChange(evt.target.value);
  };
  return /*#__PURE__*/_jsx(FormControl, {
    label: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvers"
    }),
    required: true,
    tooltipProps: {
      use: 'longform'
    },
    tooltip: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.ApprovalModal.approverTooltip"
    }),
    error: value.length > maxNumberOfApprovers,
    validationMessage: value.length > maxNumberOfApprovers && /*#__PURE__*/_jsx(FormattedMessage, {
      message: "productApprovals.approvalModalSelectError",
      options: {
        maxNumberOfApprovers,
        count: value.length - maxNumberOfApprovers
      }
    }),
    children: /*#__PURE__*/_jsx(Select, {
      anchorType: "button",
      "data-test-id": "product-approvals-approver-select",
      value: value,
      onChange: onChangeApprover,
      options: options,
      multi: true,
      multiCollapseLimit: 3,
      placeholder: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "productApprovals.selectApprover"
      })
    })
  });
};